import { DashboardModuleListItem } from '@domain-group/suit-theme'

type SortListItemProps = {
  callbacks: {
    toggleSortItem: (sortItem: string) => void,
  },
  sortItem: string,
}

const SortListItem = (props: SortListItemProps) => {
  const {
    callbacks: {
      toggleSortItem,
    },
    sortItem,
  } = props

  const split = sortItem.split('.')
  const sortDirection = split[1] === 'asc' ? 'ascending' : 'descending'

  return (
    <DashboardModuleListItem title={`${split[0]} (${sortDirection})`}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => toggleSortItem(sortItem)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default SortListItem
